module.exports = __webpack_public_path__ + "img/title-page-img.7c58489c.png";